import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to (0, 0) on every pathname change.
 *
 * React Router (v6+) deliberately does NOT scroll automatically when you
 * navigate. Without this, clicking a product card from halfway down the
 * Home page lands you on the product detail mid-page — a confusing UX.
 * Drop this component once at the top of <App /> inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // `instant` matches the browser's normal "fresh page" behavior.
    // Use 'auto' rather than 'smooth' so the user doesn't see a long
    // scroll animation — they expect the new page to start at the top.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
